// extracted by mini-css-extract-plugin
export default {"group":"group__06jIn","label":"label__-+Cte"};